const CUSTOM_ADDRESS_ID = "custom";

export { CUSTOM_ADDRESS_ID };
